import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { CommonServiceService } from 'src/app/shared/common-service.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { GlobalVariable } from 'src/app/shared/global-variable';
import { Store } from '@ngrx/store';
import { InitialState } from "src/app/store/reducer";
import { OpenAdvanceSearchModal } from '../../../transactions/store/actions';
import { Tab } from 'src/app/shared/model/tab.model';
import { TabService } from 'src/app/shared/services/tab.service';
import { UpdateSupplierComponent } from '../update-supplier/update-supplier.component';
import { DownloadService } from 'src/app/shared/download.service';
import * as moment from 'moment';
@Component({
	selector: 'app-view-supplier',
	templateUrl: './view-supplier.component.html',
	styleUrls: ['./view-supplier.component.scss']
})
export class ViewSupplierComponent implements OnInit {

	viewSupplier: any;
	viewAllSupplier: any;
	innerHeight: string;
	navigationSubscription
	reInitialise = false;

	fromRoot = true;
	selector: string = '.main-panel';
	fromIndex: any = 0;
	toIndex: any = 30;
	onSearch;
	onSearchFilter = new Subject<string>();

	isAdvancedSearchOpen: boolean = false;
	currentIndex=0
	@ViewChild('tableHeader', {static:true}) tableHeader : ElementRef
	searchInputValue: any = "";
	duration: any;
	loader: boolean = false;
	queryParams: any;

	constructor(
		public commonService: CommonServiceService,
		private route: ActivatedRoute,
		private store: Store<InitialState>,
		private router: Router,
		private downloadService: DownloadService,
		private tabService: TabService) {
		this.navigationSubscription = this.router.events.subscribe((e: any) => {
			// If it is a NavigationEnd event re-initalise the component
			if (e instanceof NavigationEnd) {
				this.initialiseInvites();
			}
		});
	}
	ngOnInit() {
		//   this.getSupplier()
		let queryParams = JSON.parse(JSON.stringify(this.route.queryParams['value']))
		if (queryParams.account_code != undefined) {
			localStorage.setItem('activeSupplierQueryParams', JSON.stringify(queryParams))
		} 
		queryParams['limit'] = 100;
        queryParams['offset'] = this.fromIndex;
        this.search(queryParams)
        this.queryParams = queryParams
		this.reInitialise = true
		this.onSearchFilter.pipe(
			debounceTime(300),
			distinctUntilChanged())
			.subscribe(value => {
			  this.filterData(value)
		});
	}
	openAdvanceSearchModal(){
		this.store.dispatch(new OpenAdvanceSearchModal({status: true,title : 'supplier'}));	
	}

	async filterData(value) {
        this.searchInputValue = value
        if (value.length >= 0) {
            this.queryParams['freetext'] = value
            let queryParams = JSON.parse(JSON.stringify(this.queryParams))
            this.queryParams = queryParams
			this.fromIndex=0
            queryParams['limit'] = 100;
            queryParams['offset'] = this.fromIndex;
            this.loader = true
            let resp = await this.getData(queryParams)
            this.loader = false
            if(resp){
                this.viewSupplier = resp['data']
                let firstRow = document.getElementById('rowIndex_1') as HTMLElement
				if(firstRow){
					firstRow.scrollIntoView()
				}
            }
           
        this.setHeight(window.innerHeight)
        } else {
            delete this.queryParams['freetext']
            this.search(this.queryParams)
            this.setHeight(window.innerHeight)
        }
    }
	initialiseInvites() {
		if (this.reInitialise) {
			this.ngOnInit()
		}
	}
	ngOnDestroy() {
		// avoid memory leaks here by cleaning up after ourselves. If we  
		// don't then we will continue to run our initialiseInvites()   
		// method on every navigationEnd event.
		if (this.navigationSubscription) {
			this.navigationSubscription.unsubscribe();
		}
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.setHeight(event.target.innerHeight)
	}

	async search(values) {
		// this.spinner.show()
		this.loader = true
		let resp = await this.getData(values)
		if(resp){
			this.loader = false
			this.viewSupplier = resp['data']
			this.duration = resp['duration']
			this.viewAllSupplier = resp['data']
			this.focusOnTableHeader()
			this.currentIndex = 0
			this.setHeight(window.innerHeight)
		}
	}

	getData(values){
		return new Promise(async (resolve, reject) => {
			this.commonService.getRequestWithQueryParamsNoLoader(`${environment.okountUrl}/globalsearch/supplier`, values).subscribe(res => {
				resolve(res)
			},err=> {
				resolve(null)
			})
		})
	}

	setHeight(height) {
		if (this.viewSupplier != undefined) {
			if (height == undefined) {
				height = window.innerHeight
			}
			if (this.viewSupplier.length <= 9) {
				this.innerHeight = 'auto';
			}
			else {
				this.innerHeight = height - 147 + 'px';			}
		}
	}


	open_supplier(supplier_id, supplier_code, supplier_name){
		let path=`${environment.name == 'v3-stage' || environment.name == 'v3-prod' ? '/v3/' : "/"}#/master/supplier/update-supplier/${supplier_id}`
		if(window.location.protocol != 'file:'){
			let supplier = supplier_id
			if(supplier) {
				this.tabService.addTab(
					new Tab(UpdateSupplierComponent, `S-${supplier_code}`, { supplier_id: supplier_id }, supplier_name)
					);
			} else {
				window.open(path,'_blank')
			}
		}else{
			var customeEventHandler = new CustomEvent("handle-window-open", {
				"detail": {
					hashPath : path
				}
			  });
			window.dispatchEvent(customeEventHandler)
		}
	}
	async onScrollDown(event) {
		console.log('scroled')
		this.fromIndex +=100
		// let toIndex = Number(this.toIndex) + 10
		let queryParams = JSON.parse(JSON.stringify(this.queryParams))
		queryParams['limit'] = 100;
		queryParams['offset'] = this.fromIndex;
		let resp = await this.getData(queryParams)
		if(resp){
			this.viewSupplier = this.viewSupplier.concat(resp['data'])
			this.setHeight(window.innerHeight)
		}
	}
	  onScrollUp(event) {
	  }

	  focusOnTableHeader(){
		if(this.tableHeader != undefined){
			this.tableHeader.nativeElement.focus()
		}
	}
	
	// @HostListener('window:keydown', ['$event'])
	onKeyDown(e: any) {
		console.log('openModalStatus : ' + GlobalVariable.openModalStatus)
		if (GlobalVariable.openModalStatus == false && GlobalVariable.openGlobalSearch == false) {
			if (e.keyCode == 40) {
				e.preventDefault();
				this.moveToNext()
			} else if (e.keyCode === 38) {
				e.preventDefault();
				this.moveToPrev()
			}
		}
	}
	moveToNext(){
		if (document.getElementById(`rowIndex_${this.currentIndex+1}`) != null) {
			document.getElementById(`rowIndex_${this.currentIndex+1}`).focus()
			this.currentIndex = this.currentIndex+1
		}
	}
	moveToPrev(){
		if (document.getElementById(`rowIndex_${this.currentIndex-1}`) != null) {
			document.getElementById(`rowIndex_${this.currentIndex-1}`).focus()
			this.currentIndex = this.currentIndex-1
		}
	}
	
	moveToIndex(i){
		document.getElementById(`rowIndex_${i+1}`).focus()
		this.currentIndex = i+1
	}

	async exportSupplierAsXLSX() {
        try{
			this.loader = true
			let downloadData = await this.getData(null);
			this.loader = false;
			let xlsxData = [];
			downloadData['data'].forEach(supplier => {
				xlsxData.push({
					"ACCOUNT CODE":supplier.account_code,
					"COMPANY NAME":supplier.name,
					"ADDRESS":supplier.address_1,
					"CITY":supplier.city_name,
					"STATE":supplier.state_name,
					"PAN":supplier.pan_number,
					"GST NO":supplier.gst_number,
					"EXPIRY DATE": supplier.gst_expiry_date ? moment(supplier.gst_expiry_date).format('DD/MM/YYYY') : '',
					"TELEPHONE":supplier.telephone,
					"MOBILE":supplier.mobile_no,
					"EMAIL 1":supplier.primary_email,
					"EMAIL 2":supplier.secondary_email,
					"STATUS":supplier.status           
					})
			});
			this.downloadService.exportAsXLSX(`supplierList`, xlsxData);
        } catch(error){
        }
       
	}
}